import { render, staticRenderFns } from "./MainQuotes.vue?vue&type=template&id=521860e0&scoped=true&"
import script from "./MainQuotes.vue?vue&type=script&lang=js&"
export * from "./MainQuotes.vue?vue&type=script&lang=js&"
import style0 from "./MainQuotes.vue?vue&type=style&index=0&id=521860e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521860e0",
  null
  
)

export default component.exports